<div id="OperatorBadge" class="p-2 bg-secondary text-white"><i class="fas fa-file-pen"></i> {{'You are entering a report received through other channels.' | translate}}.</div>
